<app-top-nav-login [bbApp]="showbbApp"></app-top-nav-login>


<div class="h-30"></div>
<div class="container">
  <div class="content" role="main">
    <div class="facility-heading"><h1>Forgot your password?</h1></div>
    <form #rpform="ngForm">
      <div class="designatedFacilityForm">
        <div class="login-fail fp-box" [hidden]="!errorDivVisible">
          <img src="/assets/tick.svg">
          <span>
            <h2>Success</h2>
            <p>Your password has been changed.</p>
            <div class="form-buttons">
              <button class="submit-form-button black-bg" (click)="gotologin()">Login</button>
            </div>
          </span>

        </div>

        <span>Enter a new password to reset the password on your account. We'll ask for this password whenever you login.</span>

        <mat-form-field appearance="outline" floatLabel="always" [hidden]="true">
          <mat-label>Username</mat-label>
          <input matInput class="form-control-textbox" [(ngModel)]="rpObj.username" name="username" required disabled="true" />
        </mat-form-field>
        <div class="mb-10"></div>

        <mat-form-field appearance="outline" floatLabel="always" [hidden]="errorDivVisible">
          <mat-label>New Password</mat-label>
          <input matInput class="form-control-textbox"  [(ngModel)]="rpObj.password" name="newPassword" type="{{revealNewPassword ? 'text' : 'password'}}" required pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{10,}" #newpassword="ngModel" />
          <button mat-icon-button matSuffix (click)="revealNewPassword = !revealNewPassword" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="revealNewPassword" type="button">
            <mat-icon>{{revealNewPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <mat-hint>Choose password you'll remember. It must be 10 or more characters and include upper and lower case letters, plus at least one number and special character</mat-hint>
          @if (newpassword.invalid && newpassword.touched) {
            <mat-error> Password must be at least 10 characters, including at least one uppercase letter, one lowercase letter, and one number and special character</mat-error>
          }
        </mat-form-field>
        <div class="mb-10"></div>

        <mat-form-field appearance="outline" floatLabel="always" [hidden]="errorDivVisible">
          <mat-label>Retype Password</mat-label>
          <input matInput class="form-control-textbox" name="confirmPassword" type="{{revealConfirmPassword ? 'text' : 'password'}}" [(ngModel)]="confirmPassword" required #confirmpassword="ngModel" />
          <button mat-icon-button matSuffix (click)="revealConfirmPassword = !revealConfirmPassword" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="revealConfirmPassword" type="button">
            <mat-icon>{{revealConfirmPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <mat-hint>Type your password again, just to make sure!</mat-hint>
          @if (confirmpassword.invalid && confirmpassword.touched) {
            <mat-error>Field is required</mat-error>
          }
        </mat-form-field>

        <div class="mb-10"></div>
        @if (rpObj.password != confirmPassword) {
          <div><span class="confirm-password-error">Passwords do not match.</span></div>
        }

        <div class="form-buttons" [hidden]="errorDivVisible">
          <input type="submit" class="submit-form-button" (click)="resetPassword(rpform)" value="Submit">
          <a routerLink="/bb-login" class="submit-form-button cancel-button"
            >Cancel</a
            >
          </div>

        </div>
      </form>
    </div>
  </div>

  <app-footer [bbapp]="showbbApp"></app-footer>
